import {SysPerm} from "@/util/SysPerm.ts";
import {ILink} from "@/types/models/ILink.ts";
import User from "@/model/User.ts";
import {UserAffiliation} from "@/types/enums/UserAffiliation.tsx";

export default function getInternalLinks(u: User) {
    let internal_links: ILink[] = []
    let internalLinkId = 0
    function addInternalLink(link: {name: string, href: string}) {
        internal_links.push({"id": `L${internalLinkId}`, name: link["name"], href: link["href"], category_id: "internal", order: internalLinkId})
        internalLinkId++
    }
    let userCanSeeCompanywideInfo = u.hasSystemPermission(SysPerm.CONTRACTOR_VIEW_COMPANYWIDE_INFO) || ![UserAffiliation.CONTRACTOR, null].includes(u.affiliation)
    addInternalLink({"name": "About", "href": "/about"})
    if (userCanSeeCompanywideInfo) {
        addInternalLink({"name": "Accountability Chart", "href": "/accountability_chart"})
        addInternalLink({"name": "API Documentation", "href": "/api_docs"})
    }
    if (u.hasSystemPermission(SysPerm.API_KEY_ADMIN)) {
        addInternalLink({"name": "API Key Management", "href": "/api_key"})
    }
    if (u.hasSystemPermission(SysPerm.AUDIT_VIEW_LOGS)) {
        addInternalLink({"name": "Audit Logs", "href": "/audit"})
    }
    addInternalLink({"name": "BravoBits", "href": "/bravobits"})
    if (userCanSeeCompanywideInfo) {
        addInternalLink({"name": "Company Calendar", "href": "/calendar"})
    }
    if (u.hasSystemPermission(SysPerm.CPM_ORDER_REPORT_VIEW)) {
        addInternalLink({"name": "CPM Order Tracking", "href": "/cpm_order_tracking"})
    }
    addInternalLink({"name": "Customers", "href": "/customers"})
    if (userCanSeeCompanywideInfo) {
        addInternalLink({"name": "Document Numbers", "href": "/document_numbers"})
    }
    if (u.hasSystemPermission(SysPerm.DOORS_READ_DOOR_ACLS) || u.hasSystemPermission(SysPerm.DOORS_MODIFY_DOOR_ACLS)) {
        addInternalLink({"name": "Door Access Managment", "href": "/doors"})
    }
    addInternalLink({"name": "Dyn DNS", "href": "/dyn_dns"})
    addInternalLink({"name": "D3 Teams", "href": "/teams"})
    if (u.hasSystemPermission(SysPerm.HAPROXY_VIEW) || u.hasSystemPermission(SysPerm.HAPROXY_MANAGE)) {
        addInternalLink({"name": "HAProxy Services", "href": "/haproxy"})
    }
    if (u.hasSystemPermission(SysPerm.JOB_LOG_VIEW)) {
        addInternalLink({"name": "Job Logging", "href": "/job_log"})
    }
    addInternalLink({"name": "License Status", "href": "/flexlm"})
    if (userCanSeeCompanywideInfo) {
        addInternalLink({"name": "MISys Stock Search", "href": "/cpm/stock"})
    }
    if (u.hasSystemPermission(SysPerm.SYSTEM_PERMISSION_MANAGER) || u.hasSystemPermission(SysPerm.SYSTEM_PERMISSION_ADMIN)) {
        addInternalLink({"name": "Permission Audit", "href": "/permission_audit"})
    }
    addInternalLink({"name": "OpenProject Workflows", "href": "/op_workflows"})
    addInternalLink({"name": "Projects", "href": "/projects"})
    addInternalLink({"name": "Scorecard", "href": "/scorecard"})
    addInternalLink({"name": "Shipping Requests", "href": "/shipping_request"})
    if (u.hasSystemPermission(SysPerm.CONFIG_ADMIN)) {
        addInternalLink({"name": "System Configuration", "href": "/config"})
    }
    if (u.hasSystemPermission(SysPerm.TIMECARD_USER)) {
        addInternalLink({"name": "Timecards", "href": "/timecards/me"})
    }
    if (u.hasSystemPermission(SysPerm.TIMECARD_MANAGER)) {
        addInternalLink({"name": "Timecard Approvals", "href": "/timecards/manage"})
    }
    if (u.hasSystemPermission(SysPerm.TIMECARD_ADMIN)) {
        addInternalLink({"name": "Timecard Administration", "href": "/timecards/admin"})
    }
    if (u.hasSystemPermission(SysPerm.TIMECARD_VIEW_REPORTS)) {
        addInternalLink({"name": "Timecard Reports", "href": "/timecards/reports"})
        addInternalLink({"name": "Task Class Hours Report", "href": "/timecards/reports/task_class_hours"})
        addInternalLink({"name": "Zbill Internal Audit Report", "href": "/timecards/reports/zbill_internal_audit"})
    }
    if (userCanSeeCompanywideInfo) {
        addInternalLink({"name": "User Directory", "href": "/users"})
        addInternalLink({"name": "Vision/Traction Organizer", "href": "/vto"})
    }
    return internal_links
}